import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import s from "./AdminSidebar.module.css";

const SupportSidebar: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const location = useLocation();

    const navLinks: { name: string; path: string }[] = [
        { name: t("userList"), path: "/support/users" },
        { name: t("trackListenedStories"), path: "/support/track-stories" },
        { name: t("tokenGeneration"), path: "/support/token-generation" },
        { name: t("reservationHistory"), path: "/support/reservation-history" },
        { name: t("generateQRCode"), path: "/support/generate-qr-code" },
        { name: t("queueAILogs"), path: "/support/queue-ai-logs" },
        { name: t("audioNorm"), path: "/support/audio-normalization" },
        { name: t("usageDecline"), path: "/support/usage-decline" },
    ];

    return (
        <aside className={s.root}>
            <h2 className={s.title}>{t("support")}</h2>
            <p className={s.section}>{t("manage")}</p>
            <ul className={s.nav}>
                {navLinks.map((link) => (
                    <li key={link.path} className={`${s.item} ${location.pathname === link.path ? s.active : ""}`}>
                        <Link className={s.link} to={link.path}>
                            {link.name}
                        </Link>
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default SupportSidebar;
